// app/translate/translate.pipe.ts

import { Pipe, PipeTransform, Inject } from '@angular/core';
import { TranslateService } from './translate.service'; // our translate service
import { TRANSLATIONS } from './translations';

@Pipe({
    name: 'translate',
})
export class TranslatePipe implements PipeTransform {

  constructor( @Inject(TRANSLATIONS) private _translations: any,
    private _translate: TranslateService) { }

    transform(value: string, args?: any[]): any {
      if (!value) return;
      return this._translate.language$.map(lang => {
        return this.translateToLang(value, lang);
      });
    }

    public translateToLang(key: string, lang: string): any {
      if (this._translations[lang] && this._translations[lang][key])
        return this._translations[lang][key];
      // console.log('TRANSLATION REQUIRED: \'' + key + '\'');
      return key;
    }
}
